import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-admin-committees-add',
  templateUrl: './admin-committees-add.component.html'
})
export class AdminCommitteesAddComponent implements OnInit {
  @Input() formdata;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null, ''],
      abbreviation: ['', ''],
      name: ['', ''],
      sort: ['', '']
    });
  
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    })
  }

  saveCommittee() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }

}
